import { createLightTheme, createDarkTheme, BrandVariants, Theme } from '@fluentui/react-components';

/**
 * Dynamics 365 Brand Colors
 * Based on Official Microsoft Dynamics 365 Brand Guidelines
 * Primary: Navy (#0a1b45), Blue (#0078d4)
 * Accents: Orange, Yellow, Ocean, Violet
 */

// Dynamics 365 Navy/Blue Brand Palette
const dynamics365Brand: BrandVariants = {
  10: '#020509',   // Darkest
  20: '#050b15',
  30: '#081223',
  40: '#0a1b45',   // Navy - Primary dark
  50: '#0d2359',
  60: '#0078d4',   // Blue - Primary brand color
  70: '#1a85d9',
  80: '#3392de',
  90: '#4da0e3',
  100: '#66ade8',
  110: '#80baed',
  120: '#99c8f2',
  130: '#b3d5f6',
  140: '#cce3fb',
  150: '#e6f1fd',
  160: '#f5f9fe',  // Lightest
};

// Create light theme with Dynamics 365 branding
export const dynamics365LightTheme: Theme = {
  ...createLightTheme(dynamics365Brand),
  // Custom overrides for Dynamics 365 look
  colorBrandBackground: '#0078d4',
  colorBrandBackgroundHover: '#106ebe',
  colorBrandBackgroundPressed: '#005a9e',
  colorBrandForeground1: '#0078d4',
  colorBrandForeground2: '#005a9e',
  colorCompoundBrandBackground: '#0078d4',
  colorCompoundBrandBackgroundHover: '#106ebe',
  colorCompoundBrandBackgroundPressed: '#005a9e',
  colorCompoundBrandForeground1: '#0078d4',
  colorCompoundBrandForeground1Hover: '#106ebe',
  colorCompoundBrandForeground1Pressed: '#005a9e',
  colorCompoundBrandStroke: '#0078d4',
  colorCompoundBrandStrokeHover: '#106ebe',
  colorCompoundBrandStrokePressed: '#005a9e',
};

// Create dark theme with Dynamics 365 branding
export const dynamics365DarkTheme: Theme = {
  ...createDarkTheme(dynamics365Brand),
  colorBrandBackground: '#2899f5',
  colorBrandBackgroundHover: '#3aa0f5',
  colorBrandBackgroundPressed: '#0078d4',
  colorBrandForeground1: '#2899f5',
  colorBrandForeground2: '#3aa0f5',
  colorCompoundBrandBackground: '#2899f5',
  colorCompoundBrandBackgroundHover: '#3aa0f5',
  colorCompoundBrandBackgroundPressed: '#0078d4',
  colorCompoundBrandForeground1: '#2899f5',
  colorCompoundBrandForeground1Hover: '#4da9f7',
  colorCompoundBrandForeground1Pressed: '#3aa0f5',
  colorCompoundBrandStroke: '#2899f5',
  colorCompoundBrandStrokeHover: '#3aa0f5',
  colorCompoundBrandStrokePressed: '#0078d4',
};

// Official Dynamics 365 Brand Guidelines Color Tokens
export const dynamics365Tokens = {
  // Primary Palette
  navy: '#0a1b45',
  blue: '#0078d4',
  lightTan: '#eae4dc',
  
  // Accent Colors (Bright)
  orange: '#d83b01',
  yellow: '#ffb900',
  ocean: '#13b2b4',
  violet: '#770180',
  
  // Accent Colors (Light)
  lightOrange: '#ff9349',
  lightYellow: '#fef000',
  lightBlue: '#50e6ff',
  lightPurple: '#d59dff',
  
  // Neutral Grays
  extraDarkGray: '#2f2f2f',
  mediumGray: '#a4a4a4',
  extraLightGray: '#f2f2f2',
  white: '#ffffff',
  
  // Gradients (Official Dynamics 365 style)
  gradientNavyBlue: 'linear-gradient(135deg, #0a1b45 0%, #0078d4 100%)',
  gradientBlueOcean: 'linear-gradient(135deg, #0078d4 0%, #13b2b4 100%)',
  gradientVioletPurple: 'linear-gradient(135deg, #770180 0%, #d59dff 100%)',
  gradientHeader: 'linear-gradient(90deg, #0a1b45 0%, #0078d4 100%)',
  gradientButton: 'linear-gradient(135deg, #0078d4 0%, #106ebe 100%)',
  
  // Shadows
  shadowCard: '0 2px 8px rgba(10, 27, 69, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)',
  shadowCardHover: '0 8px 24px rgba(0, 120, 212, 0.15), 0 2px 8px rgba(0, 0, 0, 0.08)',
  shadowHeader: '0 2px 12px rgba(10, 27, 69, 0.12)',
};

export default dynamics365LightTheme;
